// extracted by mini-css-extract-plugin
export var content = "_cy-3";
export var list = "_cy-4";
export var settingsContent = "_cy-7";
export var settingsPanel = "_cy-8";
export var state = "_cy-6";
export var triggerBadge = "_cy-2";
export var triggerButton = "_cy-1";
export var triggerShell = "_cy-0";
export var unreadDot = "_cy-5";